import React, { useState, useEffect, useRef } from 'react'
import { postForm } from '../../../ajax'
import dropin from 'braintree-web-drop-in'

export default function BraintreeForm({league, type, cards, formData, paymentParams, onBack, onComplete}) {
  const [error, setError] = useState()
  const [processing, setProcessing] = useState(false)
  const [activeCard, setActiveCard] = useState('new')
  const [dropinInstance, setDropinInstance] = useState()
  const [payButtonActive, setPayButtonActive] = useState(false)
  const cardsRef = useRef([])
  const newCard = activeCard == 'new'
  const amount = parseFloat(type == 'team' ? league.team_price : league.individual_price)

  const initializeBraintree = () => dropin.create({
    authorization: paymentParams.authorization,
    container: '#dropin-container',
    applePay: {
      displayName: 'Plei order',
      paymentRequest: {
        total: {
          label: 'Plei order',
          amount: amount.toString()
        }
      }
    },
    googlePay: {
      googlePayVersion: 2,
      merchantId: paymentParams.merchand_id,
      transactionInfo: {
        totalPriceStatus: 'FINAL',
        totalPrice: amount.toString(),
        currencyCode: 'USD'
      },
      allowedPaymentMethods: [{
        type: 'CARD'
      }]
    }
  }, function (createErr, dropinInstance) {
    dropinInstance.on('paymentOptionSelected', (event) => {
      document.getElementsByClassName('braintree-toggle')[0].addEventListener('click', () => {
        setPayButtonActive(false)
      })

      if (event.paymentOption == 'card') {
        setPayButtonActive(true)
      }
    })

    dropinInstance.on('paymentMethodRequestable', (event) => {
      if (event.paymentMethodIsSelected && event.type != 'CreditCard') {
        sendNonceToServer(dropinInstance);
      }
    })

    setDropinInstance(dropinInstance)
  })

  const updateDropin = () => {
    if (!dropinInstance) return null

    dropinInstance.getAvailablePaymentOptions().map(option => {
      if (option == 'googlePay') {
        dropinInstance.updateConfiguration('googlePay', 'transactionInfo', {
          totalPriceStatus: 'FINAL',
          totalPrice: amount.toString(),
          currencyCode: 'USD'
        })
      } else if (option == 'applePay') {
        dropinInstance.updateConfiguration('applePay', 'paymentRequest', {
          total: {
            label: 'Plei order',
            amount: amount.toString()
          }
        })
      } else {
        dropinInstance.updateConfiguration(option, 'amount', amount)
      }
    })
  }

  const setDefaultCard = () => {
    const defaultCard = cards.find(card => card.default)
    defaultCard && setActiveCard(defaultCard.token)
  }

  useEffect(() => {
    initializeBraintree()
    updateDropin()
    setDefaultCard()
  }, [])

  useEffect(() => {
    const defaultCardIndex = cards.findIndex(card => card.default)
    if (defaultCardIndex != -1) cardsRef.current[defaultCardIndex].focus()
  }, [cardsRef.current])

  const createRegistration = async (options) => {
    formData.append('payment[type]', options.type)
    formData.append('payment[token]', options.token)
    const response = await postForm(`/plugin/leagues/${league.id}/registrations`, formData)
    const json = await response.json()
    setProcessing(false)
    if (json.error) setError(json.error)
    else onComplete(json.data)
  }

  const handlePayment = async (paymentMethodId) => {
    setProcessing(true)
    setError(null)
    createRegistration({type: 'card_number', token: paymentMethodId})
  }

  const sendNonceToServer = () => {
    dropinInstance && dropinInstance.requestPaymentMethod(function (err, payload) {
      if (err) return setError(err.message)

      const nonce = payload != null ? payload.nonce : ''
      handlePayment(nonce)
    })
  }

  const chargeStored = (method) => {
    setProcessing(true)
    createRegistration({type: 'saved_card', token: method})
  }

  const activeClass = (token) => {
    return activeCard == token ? ' active' : ''
  }

  const checkCardKeyDown = (e, card) => {
    if (e.key === 'Enter') chargeStored(card.token)
  }

  const cardsList = () => {
    return <div className='stored-cards-list'>
      { cards.map((card, i) => {
          return <div 
            className={'stored-card' + activeClass(card.token)}
            key={i}
            ref={el => cardsRef.current[i] = el}
            tabIndex={i}
            onKeyDown={(e) => checkCardKeyDown(e, card)}
            onClick={() => setActiveCard(card.token)}
          >
            <div className='stored-card__desc'>
              <div className={'card-selection' + activeClass(card.token)}></div>
              { card.image_url ? <img src={card.image_url} /> : <div className={'brand-img' + ` ${card.name}-img`}></div> }
              <div>
                <div className='card-ending'>{`${card.title} ending in ${card.last_4}`}</div>
                <div className='card-expiry'>{`Expiry ${card.exp_month}/${card.exp_year}`}</div>
              </div>
            </div>
          </div>
        })
      }
      <div className='stored-card' onClick={() => setActiveCard('new')}>
        <div className='stored-card__desc'>
          <div className={'card-selection' + activeClass('new')}></div>
          <div className='card-new'>New card</div>
        </div>
      </div>
    </div>
  }

  const clickConfirm = (e) => {
    e.preventDefault()
    newCard ? sendNonceToServer() : chargeStored(activeCard)
  }

  return (
    <form className={`payment-form ${processing ? ' isLoading' : ''}`}>
      { error && <div className='payment-error'>{error}</div> }
      <div>
        { processing && <div className='animated-spinner'></div> }
        { cardsList() }
        <div id='dropin-container' className={newCard ? '' : 'hidden'}></div>
        <div className='payment-buttons'>
          <div className='button button-back' onClick={onBack}>Back</div>
          <button className='button button-next' disabled={!payButtonActive && newCard} onClick={clickConfirm}>
            Confirm and Pay
          </button>
        </div>
      </div>
    </form>
  )
}
